import { AppContextType } from './index';

import memoize from 'memoizee';
import { UserHelper } from '../helpers/user';
import { GROUP_ACCOUNT_TYPES } from '../constants';
import { SubsHelper } from '../helpers/subscription';

const getArrayMemoize = memoize(
  (...args) => {
    return [...args];
  },
  { length: false, max: 1000 },
);

export class AppContextSelectors {
  static getLoading(context: AppContextType) {
    return getArrayMemoize(context.isLoading, context.setIsLoading);
  }

  static getUpdateGroup(context: AppContextType) {
    return context.updateGroup;
  }

  static makeGetBusiness = memoize(
    (groupId: string) => {
      return (context: AppContextType) => {
        if (!groupId) return undefined;
        // @ts-ignore // FIXME: type error
        return UserHelper.getGroupFromUser(context.currentUser, {
          type: GROUP_ACCOUNT_TYPES.BUSINESS,
          id: groupId,
        });
      };
    },
    { length: false },
  );

  static makeGetSubscription = memoize(
    (groupId: string) => {
      return (context: AppContextType) => {
        if (!groupId) return undefined;
        return SubsHelper.getSubscriptionByGroupId(context.currentSubscriptions, { groupId });
      };
    },
    { length: false },
  );

  static getUpdateSubscription(context: AppContextType) {
    return context.updateSubscription;
  }

  static getReloadCurrentUser(context: AppContextType) {
    return context.reloadCurrentUser;
  }

  static getClearSessionAndRedirectToLogin(context: AppContextType) {
    return context.clearSessionAndRedirectToLogin;
  }

  static getSetCurrentSubscriptions(context: AppContextType) {
    return context.setCurrentSubscriptions;
  }
}
